/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconAmex from '@telus-uds/palette-koodo/build/rn/icons/Amex'
import PaletteIconTimes from '@telus-uds/palette-koodo/build/rn/icons/Times'
import PaletteIconCreditCard from '@telus-uds/palette-koodo/build/rn/icons/CreditCard'
import PaletteIconMasterCard from '@telus-uds/palette-koodo/build/rn/icons/MasterCard'
import PaletteIconEyeMasked from '@telus-uds/palette-koodo/build/rn/icons/EyeMasked'
import PaletteIconEyeUnmasked from '@telus-uds/palette-koodo/build/rn/icons/EyeUnmasked'
import PaletteIconVisa from '@telus-uds/palette-koodo/build/rn/icons/Visa'
import PaletteIconCheckCircleFilled from '@telus-uds/palette-koodo/build/rn/icons/CheckCircleFilled'
import PaletteIconExclamationOctagon from '@telus-uds/palette-koodo/build/rn/icons/ExclamationOctagon'
const theme = {
  appearances: {
    focus: {
      description: 'Focus states for some input elements are well supported across web, RN, ios and android',
      type: 'state',
      values: [ true ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    numeric: {
      description: 'capability to only allow numbers',
      type: 'variant',
      values: [ true ]
    },
    password: {
      description: 'capability that helps masking and unmasking text',
      type: 'variant',
      values: [ true ]
    },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning', 'feature' ]
    }
  },
  rules: [
    {
      if: { hover: true, inactive: null },
      tokens: { backgroundColor: '#efefef', borderColor: '#000000' }
    },
    {
      if: { hover: true, validation: 'success' },
      tokens: {
        backgroundColor: '#efefef',
        borderColor: '#000000',
        icon: PaletteIconCheckCircleFilled,
        iconColor: '#1c7b2b'
      }
    },
    {
      if: { hover: true, validation: 'error' },
      tokens: {
        backgroundColor: '#efefef',
        borderColor: '#000000',
        iconColor: '#c9370b'
      }
    },
    {
      if: { hover: false, validation: 'success' },
      tokens: {
        borderColor: '#1c7b2b',
        icon: PaletteIconCheckCircleFilled,
        iconColor: '#1c7b2b'
      }
    },
    {
      if: { hover: false, validation: 'error' },
      tokens: {
        borderColor: '#c9370b',
        icon: PaletteIconExclamationOctagon,
        iconColor: '#c9370b'
      }
    },
    {
      if: { focus: true, inactive: null },
      tokens: { borderColor: '#7a3dfc', borderWidth: 3, icon: null }
    },
    {
      if: { inactive: true },
      tokens: { backgroundColor: '#efefef', borderColor: '#efefef' }
    }
  ],
  tokens: {
    amexIcon: PaletteIconAmex,
    backgroundColor: '#ffffff',
    borderColor: '#000000',
    borderRadius: 4,
    borderWidth: 1,
    buttonSize: 32,
    buttonsGap: 0,
    buttonsPaddingRight: 0,
    clearButtonIcon: PaletteIconTimes,
    color: '#000000',
    defaultCreditIcon: PaletteIconCreditCard,
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '400',
    icon: null,
    iconColor: 'rgba(0, 0, 0, 0)',
    iconLeftGap: 5,
    iconLeftPaddingBottom: 5,
    iconSize: 24,
    leftIconPaddingBottom: 5,
    lineHeight: 1.5,
    masterCardIcon: PaletteIconMasterCard,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderWidth: 0,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    passwordHideButtonIcon: PaletteIconEyeMasked,
    passwordShowButtonIcon: PaletteIconEyeUnmasked,
    visaIcon: PaletteIconVisa
  }
}
export default theme
